const formatTxt = [
  {
    name: 'pdf',
    href: 'http://www.marca.es'
  },
  {
    name: 'xls',
    href: 'http://www.elmundo.es'
  }
];

export { formatTxt };
